import { User } from '@/core/entity';
import { IUserGateway, UserInput, PresenterFunc, UpdaterFunc, IFileGateway } from '@/core/interface';
import { CreateUser, UpdateUser } from '@/core/usecase';
import { Fragment } from '@/core/interface/common';

export class UserController {
  constructor(
    private readonly fileGw: IFileGateway,
    private readonly userGateway: IUserGateway,
  ) { }

  public create(
    input: UserInput,
    presenter: PresenterFunc<User | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    const useCase = new CreateUser(this.fileGw, this.userGateway);

    useCase.execute(input, presenter, fragment, updater);
  }

  public update(
    id: string,
    input: UserInput,
    presenter: PresenterFunc<User | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    const useCase = new UpdateUser(this.fileGw, this.userGateway);

    useCase.execute(id, input, presenter, fragment, updater);
  }
}
